<common-upload-dialog> </common-upload-dialog>
<router-outlet></router-outlet>
<manage-mx-taskbar></manage-mx-taskbar>
<!-- @if(userId){
<chat-widget></chat-widget>
} -->
<mat-sidenav-container class="example-container">
  <mat-sidenav
    id="sidenavContainer"
    #homePageDrawer
    [mode]="'side'"
    style="overflow-x: hidden; overflow-y: auto; visibility: visible !important"
    class="app__stepper__config-container"
    [ngClass]="{
        'top-[52px]': switchFromUser && (openDiscoveryCategoryConfig),
        'top-10': switchFromUser && !(openDiscoveryCategoryConfig),
        'w-[1130px] xl:w-[1130px]': openDiscoveryCategoryConfig,
        'top-0': !switchFromUser
    }"
    [(opened)]="openSideBar"
    position="end"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [disableClose]="true"
    (closed)="handleMainSideNav(false)"
    (opened)="handleMainSideNav(true)"
  >
    <div class="w-full h-full">
      @if(accountSetupOpened) {
      <account-setup [accountType]="accountType" (closeAccountSetupSideBarEventEmitter)="closeDrawerEventHandler()"> </account-setup>
      } @if (securityPrivacySetupOpened) {
      <security-privacy-setup [accountType]="accountType" (closeAccountSetupSideBarEventEmitter)="closeDrawerEventHandler()">
      </security-privacy-setup>
      } @if (networkSetupOpened) {
      <network-setup [accountType]="accountType" (closeAccountSetupSideBarEventEmitter)="closeDrawerEventHandler()"> </network-setup>
      } @if (onboardingResponsibilityOpened) {
      <network-responsibilities [accountType]="accountType" (closeOnboardingSideBarEventEmitter)="closeDrawerEventHandler()">
      </network-responsibilities>
      } @if (openDiscoveryCategoryConfig){
      <discovery-configuration
        [discoveryCategoryConfigType]="discoveryCategoryConfigType"
        (closeDiscoveryCategoryConfig)="closeDiscoveryCategoryConfigEventEmitter()"
        [switchFromUser]="switchFromUser"
      ></discovery-configuration>
      }
    </div>
  </mat-sidenav>
</mat-sidenav-container>
